export const DEFAULT_COLUMNS = {
  dataRecipientGln: { headerName: 'Data Recipient GLN' },
  dataSourceGln: { headerName: 'Data Source GLN' },
  gtin: { headerName: 'GTIN' },
  publicationDate: { format: 'date' },
  targetMarket: {},
};
